import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { INavigationEvent } from '../../ngrx/aumico.layout.action';

@Injectable({
    providedIn: 'root',
})
export class SubNavigationService {
    onChangeTabEvent$ = new BehaviorSubject(null);

    onChangeTab(event: INavigationEvent) {
        this.onChangeTabEvent$.next(event);
    }
}
